/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState } from "react";
import "./Portfolio.css";
import CarnovaLogo from "../assets/images/Carnovalogo.png";
import AIAutomationImg from "../assets/images/ai-automation-expert-workflow-automation-service.png";

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState("all");

  const projects = [
    {
      id: 1,
      title: "Audio NLP Learning Platform",
      category: "web",
      image: "fas fa-headphones",
      description:
        "Interactive NLP learning platform with real-time speech processing.",
      technologies: ["React", "TensorFlow", "FastAPI", "Python"],
      liveLink: "#",
      githubLink: "https://github.com/umar-zayyar/Audio-NLP",
    },
    {
      id: 2,
      title: "HomeSure Application",
      category: "app",
      image: "fas fa-home",
      description:
        "A modern property management mobile app for owners & tenants.",
      technologies: ["React Native", "Stripe", "Node.js", "MongoDB"],
      liveLink: "#",
      githubLink: "https://github.com/umar-zayyar/Home-Sure-App",
    },
    {
      id: 3,
      title: "Carnova Foodz Meat App",
      category: "app",
      image: CarnovaLogo,
      description:
        "A premium delivery and take away app for fresh & frozen halal meat products.",
      technologies: ["React Native", "React Navigation", "Context API"],
      liveLink: "https://play.google.com/store/apps/details?id=com.carnova.foodz",
      githubLink: "#",
    },
    {
      id: 4,
      title: "AI Automation ChatBot",
      category: "web",
      image: AIAutomationImg,
      description:
        "AI-powered customer service automation with NLP and workflow AI.",
      technologies: ["Python", "OpenAI", "React"],
      liveLink: "#",
      githubLink: "#",
    },

    {
      id: 5,
      title: "Restaurant POS System",
      category: "POS",
      image: "fas fa-cash-register",
      description:
        "Custom POS system for retail businesses with inventory management and sales reporting.",
      technologies: ["PHP", "Laravel", "MY SQL", "JavaScript"],
      liveLink: "https://lightcoral-porpoise-202945.hostingersite.com/",
      githubLink: "#",
    },

    {
      id: 6,
      title: "Khushab Ras Multibranch POS",
      category: "POS",
      image: "fas fa-store",
      description:
        "Multibranch POS system for Khushab Ras with centralized management and reporting.",
      technologies: ["PHP", "Laravel", "MY SQL", "JavaScript"],
      liveLink: "https://lightsalmon-cobra-955467.hostingersite.com/",
      githubLink: "#",
    },
  ];

  const filters = [
    { key: "all", label: "All Projects" },
    { key: "web", label: "Web Applications" },
    { key: "app", label: "Mobile Apps" },
    { key: "POS", label: "POS Systems" },
  ];

  const filteredProjects =
    activeFilter === "all"
      ? projects
      : projects.filter((p) => p.category === activeFilter);

  return (
    <section className="section portfolio" id="portfolio">
      <div className="container">

        <div className="section-title">
          <h2>My Portfolio</h2>
          <p>Showcasing my latest projects and creative work</p>
        </div>

        {/* Filters */}
        <div className="portfolio-header">
          <div className="portfolio-filters">
            {filters.map((f) => (
              <button
                key={f.key}
                onClick={() => setActiveFilter(f.key)}
                className={`filter-btn ${activeFilter === f.key ? "active" : ""}`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        {/* Projects Grid */}
        <div className="portfolio-grid">
          {filteredProjects.map((project) => (
            <div key={project.id} className="portfolio-card">

              <div className="card-header">
                <div className="project-icon">
                  {typeof project.image === "string" && project.image.startsWith("fa") ? (
                    <i className={project.image}></i>
                  ) : (
                    <img src={project.image} alt={project.title} className="project-logo" />
                  )}
                </div>

                <div className="project-info">
                  <h3>{project.title}</h3>
                  <span className="project-category">{project.category}</span>
                </div>
              </div>

              <div className="card-body">
                <p>{project.description}</p>

                <div className="technologies">
                  {project.technologies.map((tech, i) => (
                    <span key={i} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>

              <div className="card-footer">
                <a href={project.liveLink} target="_blank" className="project-link">
                  <i className="fas fa-external-link-alt"></i> Live Demo
                </a>

                <a href={project.githubLink} target="_blank" className="project-link">
                  <i className="fab fa-github"></i> GitHub
                </a>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Portfolio;
